import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Router from "./routes/routes";

import { useEffect, useLayoutEffect, useState } from "react";
import { useGetLoggedInUser } from "./api/loggedinUser";
import { useGetConfig } from "./api/config";
import { Helmet } from "react-helmet-async";

function App() {
  const themeString = localStorage.getItem("theme");
  const themes = themeString ? JSON.parse(themeString) : null;
  const googleFont =
    typeof themes?.google_font === "string" ? themes.google_font.trim() : "";
  const [immersive, setImmersive] = useState<Boolean>();

  useEffect(() => {
  document.title = process.env.REACT_APP_BRAND || "Web-Twin";
}, []);

  const {
    data,
    isLoading: isLoadingConfig,
    isSuccess: isSuccessConfig,
  } = useGetConfig();

  // // side effect to update the font of the application in initial page load
  // useLayoutEffect(() => {
  //   //updating the primary color property of nav bar dynamically
  //   document.documentElement.style.setProperty(
  //     "--fonts-options",
  //     themes?.google_font
  //   );
  // }, [themes]);


  useLayoutEffect(() => {
    if (!googleFont) return;
    document.documentElement.style.setProperty("--fonts-options", googleFont);
  }, [googleFont]);


  useEffect(() => {
    if (isSuccessConfig && data?.data?.immersive_experience === true) {
      setImmersive(true);
    } else {
      setImmersive(false);
    }

    if (isSuccessConfig && data?.data?.theme_settings) {
      localStorage.setItem("theme", JSON.stringify(data?.data?.theme_settings));
    }
  }, [isSuccessConfig, data]);

  // roles that controls the accessing certain features
  const { data: loggedInUser, isLoading } = useGetLoggedInUser();

  return (
    <>
      {googleFont && (
        <Helmet>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
          <link
            href={`https://fonts.googleapis.com/css2?family=${googleFont}:wght@100;200;300;400;500;600;700;800;900&display=swap`}
            rel="stylesheet"
          />
        </Helmet>
      )}
      <div className="App">
        <ToastContainer />
        <Router
          user={loggedInUser?.data}
          immersive={immersive}
          browseWithoutLogin={data?.data?.browse_without_login}
          isConfigLoading={isLoadingConfig}
          isLoading={isLoading}
        />
      </div>
    </>
  );
}

export default App;